import type { MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Feeds · MinHub' },
	{
		name: 'description',
		content: 'Public Feeds on MinHub live at minhub.app/f/{slug}.',
	},
]

export default function PublicFeedsIndex() {
	return (
		<main className="min-h-screen bg-white px-4 py-16 text-center text-gray-900">
			<h1 className="text-2xl font-semibold">Feeds</h1>
			<p className="mt-2 text-gray-600">
				A public Feed has its own link: minhub.app/f/…
			</p>
		</main>
	)
}
